export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-m@2x.d9ec8fc5.webp";